<template>
  <Modal
    class="scoped"
    :title="title"
  >
    <InsightsQualitativeTopicForm
      :organisation-id="organisationId"
      :topic-id="topicId"
      :topic-type="topicType"
      @saved="topicSaved"
    />
  </Modal>
</template>

<script>
import Modal from "shared/components/core/modals/Modal.vue";

import InsightsQualitativeTopicForm from "src/components/insights/InsightsQualitativeTopicForm.vue";

export default {
  name: "InsightsTopicFormModal",
  components: {
    Modal,
    InsightsQualitativeTopicForm,
  },
  props: {
    organisationId: {
      type: [Number, String],
      required: true,
    },
    topicId: {
      type: [Number, String],
      default: null,
    },
    topicType: {
      type: String,
      required: true,
    },
  },
  emits: ["confirm", "close"],
  computed: {
    title() {
      return this.topicId ? `Edit ${this.topicType}` : `Add ${this.topicType}`;
    },
  },
  methods: {
    topicSaved(topic) {
      this.$emit("confirm", topic);
      this.close();
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
